<template>
    <div>
        <div class="row">
            <input-text class="col-12 col-md-4" :readonly="form.id" @blur="buscarFator" label="Ano" type="number" :min="1960" :max-length="4" v-model="form.ano" ref="ano" required/>
            <input-select class="col-12 col-md-4" :disabled="form.id" @input="buscarFator" label="Mês" v-model="form.mes" :options="options.meses" ref="mes" required/>
            <input-text class="col-12 col-md-4" label="Taxa selic(%)" type="number" :min="0" :max="100" :max-length="10" v-model="form.taxa" ref="valor" required/> 
        </div>
    </div>
</template>
<script>
import InputText from "@/components/inputs/InputText";
import InputSelect from "@/components/inputs/InputSelect";
import helpers from "@/common/utils/helpers";
import {FormMixin} from "@/common/mixins/FormMixin";
import {AlertasMixin} from "@/common/mixins/AlertasMixin";
import MovimentacaoFinanceiraService from "@/common/services/movimentacao_financeira/movimentacao_financeira.service";
export default {
    mixins: [FormMixin, AlertasMixin],
    components : {
        InputText,
        InputSelect,
        //InputMoney
    },
    props : {
        form : {
            required : true,
        }
    },
    data : () => ({
        options : {
            meses : helpers.retornarMeses(),
        }
    }),
    methods : {
        buscarFator : function(){
            if(!this.form.ano || !this.form.mes){
                return;
            }

            MovimentacaoFinanceiraService.buscarFatorAcumulado(this.form.mes, this.form.ano).then(res => {
                if(!this.form.id){
                    this.form.taxa = res.data.data.taxa;
                }
            })
        }
    }
}
</script>
<style>
</style>